"use strict";

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _logo = _interopRequireDefault(require("../logo"));

var _mainHeader = _interopRequireWildcard(require("../main-header"));

var _index = _interopRequireDefault(require("./index.scss"));

// Default implementation for Main header
// ======================================
var DefaultMainHeader = function DefaultMainHeader(props) {
  return _react["default"].createElement(_mainHeader["default"], null, _react["default"].createElement(_mainHeader.HeaderCenter, null, _react["default"].createElement(_logo["default"], {
    url: props.homeUrl
  })), props.onLogin && !props.isLoggedIn && _react["default"].createElement(_mainHeader.HeaderRight, null, _react["default"].createElement("button", {
    type: "tertiary",
    onClick: props.onLogin,
    className: _index["default"].link
  }, "Sign in")), props.onLogout && props.isLoggedIn && _react["default"].createElement(_mainHeader.HeaderRight, null, _react["default"].createElement("button", {
    type: "tertiary",
    onClick: props.onLogout,
    className: _index["default"].link
  }, "Sign out")));
};

DefaultMainHeader.propTypes = {
  homeUrl: _propTypes["default"].string.isRequired,
  isLoggedIn: _propTypes["default"].bool,
  onLogin: _propTypes["default"].func,
  onLogout: _propTypes["default"].func
};
var _default = DefaultMainHeader;
exports["default"] = _default;